module.exports = __webpack_public_path__ + "static/media/cloud.4007b802.png";